function changeFilter(event) {
	if (event.target.nodeName === 'SELECT') {
		window.location.href = event.target.value;
	}
}

function ready() {
	window.removeEventListener('load', ready);
	document.removeEventListener('DOMContentLoaded', ready);

	var filterForm = document.querySelector('.hero-posts__filt-form');
	if (filterForm) {
		filterForm.addEventListener('change', changeFilter);
	}
}

if (document.readyState.match(/(completed|interactive)/i)) {
	ready();
} else {
	window.addEventListener('load', ready);
	document.addEventListener('DOMContentLoaded', ready);
}
